/*
 * @Author: Teemo Ding
 * @Date: 2021-09-03 11:16:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-05-05 10:57:23
 * @FilePath: /unifyxp-v2-store-portal/src/pages/AuditTrail/Communication/Components/StatusTag/index.tsx
 */
import React from 'react';
import { LogStatus } from '@/src/types/common/communication';
import css from './css.module.less';

const StatusTag = (props) => {
  const { status, className, label } = props;
  const tagColor = {
    [LogStatus.Sent]: {
      color: '#B7EB8F',
      backgroundColor: '#F6FFED',
    },
    [LogStatus.Failed]: {
      color: '#FFE58F',
      backgroundColor: '#FFFBE6',
    },
    [LogStatus.Pending]: {
      color: '#B9BCBF',
      backgroundColor: '#F4F5F7',
    },
  };
  return status ? (
    <div
      className={`${className} ${css.statusTag}`}
      style={{
        ...(tagColor[status] || {
          color: '#1B93C5',
          backgroundColor: '#F4FCFF',
        }),
        border: `1px solid ${(tagColor[status] || {}).color || '#1B93C5'}`,
      }}>
      {label}
    </div>
  ) : null;
};

export default StatusTag;
